import { useNavigationContext } from '../../../contexts/NavigationContext';
import MainLayout from '../../../components/Display/MainLayout';
import AttendeesPage from './Attendees/AttendeesPage';
import EventPage from './Events/EventPage';
import './MaisonMousse.scss';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (

    <MainLayout enableAnalytics={true} scope={'maisonmousse'} websiteLabel={"maisonmousse.fr"}>
      <EventPage isActive={navigationContext.activeAppKey === 'mmevent'} />
      <AttendeesPage isActive={navigationContext.activeAppKey === 'attendees'} />
    </MainLayout>
  );
}

export default Home;
